import React from 'react'
import './TeacherTimeTable.css'
function TeacherTimeTable() {
    return (
        <div className ='t-time-table'>
            <p>09:00 am</p>
        </div>
    )
}

export default TeacherTimeTable
